var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app fond",attrs:{"id":"app"}},[_c('div',[_c('h1',[_vm._v("La page n'existe pas")]),_vm._v(" "),_c('p',{staticClass:"paragraphe-en-tete"},[_vm._v("Veuillez retournez à la page d'"),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Accueil")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09a20136","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Erreur404.vue
// module id = null
// module chunks = 